import { filter, size } from 'lodash'

const allSelectedByGroup = (selectedItems, allItems, group) => {
  const selectedInGroup = filter(selectedItems, ['group', group])
  const optionsInGroup = filter(allItems, ['group', group])
  return (
    size(optionsInGroup) > 0 && size(selectedInGroup) === size(optionsInGroup)
  )
}

const someSelectedByGroup = (selectedItems, allItems, group) => {
  const selectedInGroup = filter(selectedItems, ['group', group])
  const optionsInGroup = filter(allItems, ['group', group])
  return (
    size(selectedInGroup) > 0 && size(selectedInGroup) < size(optionsInGroup)
  )
}

export default {
  allSelectedByGroup,
  someSelectedByGroup,
}
